export default __webpack_public_path__ + "static/media/trip-planner.5e7d0b25.svg";